module.exports = __webpack_public_path__ + "static/media/delete_black_24dp.fdffca99.svg";